var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHumanWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_494_194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3268 15.3412C27.0077 15.3412 29.9916 12.3573 29.9916 8.67646C29.9916 4.99562 27.0077 2.01172 23.3268 2.01172C19.646 2.01172 16.6621 4.99562 16.6621 8.67646C16.6621 12.3573 19.646 15.3412 23.3268 15.3412Z",
    stroke: "white",
    strokeWidth: 3.33237,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33105 17.0078C12.6572 20.2524 17.919 22.0064 23.3267 22.0064C28.7344 22.0064 33.9962 20.2524 38.3224 17.0078",
    stroke: "white",
    strokeWidth: 3.33237,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3252 21.4404V35.3364H18.3281V21.4404",
    stroke: "white",
    strokeWidth: 3.33237,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3281 35.335V45.3321",
    stroke: "white",
    strokeWidth: 3.33237,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3252 35.335V45.3321",
    stroke: "white",
    strokeWidth: 3.33237,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_494_194"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.6532,
    height: 46.6532,
    fill: "white",
    transform: "translate(0 0.34668)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumanWhite);
export default __webpack_public_path__ + "static/media/human-white.4a78c2da37245c3999b90a77a285ad34.svg";
export { ForwardRef as ReactComponent };